import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router.js'

const AudioContext = window.AudioContext || window.webkitAudioContext
window.acontext = new AudioContext()

createApp(App).use(router).mount('#app')
